import PDApp from './modules/pdapp';
$(function () {
    window.PDApp = new PDApp();
});
